import React from "react";
import "./Home.css";
import Hero from "../Hero/Hero";
import OneClickSection from "../OneClickSection/OneClickSection";
import Services from "../Services/Services";
import Banner from "../Banner/Banner";
import Process from "../Process/Process";
import Strategies from "../Strategies/Strategies";
import WhyChooseUs from "../WhyChooseUs/WhyChooseUs";

const Home = () => {
  return (
    <main className="sssHome">
      <Hero />

      <section className="sssHome__block">
        <div className="sssHome__intro">
          <h2>From unbox to online — without the guesswork</h2>
          <p>
            Pick your device type, follow a guided flow, or talk to a specialist who walks you through every step.
          </p>
        </div>
        <OneClickSection />
      </section>

      <section className="sssHome__block sssHome__block--mist">
        <div className="sssHome__intro">
          <h2>What we help you set up</h2>
          <p>Printers, routers, and Wi‑Fi extenders — clear steps, brand-specific guides, and live help when stuck.</p>
        </div>
        <Services />
      </section>

      <Banner />

      <section className="sssHome__block">
        <div className="sssHome__intro">
          <h2>A simple path to a working device</h2>
          <p>No jargon walls. Just the right checks in the right order — then confirmation that you’re connected.</p>
        </div>
        <Process />
      </section>

      <section className="sssHome__block sssHome__block--ink">
        <div className="sssHome__intro sssHome__intro--light">
          <h2>Built for real homes and small offices</h2>
          <p>Whether it’s a first printer or a weak Wi‑Fi corner, we focus on fixes you can finish today.</p>
        </div>
        <Strategies />
      </section>

      <section className="sssHome__block">
        <div className="sssHome__intro">
          <h2>Why people choose Smart Setup Solutions</h2>
          <p>Fast guidance, brand-aware flows, and specialists who stay on the line until it works.</p>
        </div>
        <WhyChooseUs />
      </section>
    </main>
  );
};

export default Home;
